import { render, staticRenderFns } from "./add-components.vue?vue&type=template&id=10ba9164&scoped=true"
import script from "./add-components.vue?vue&type=script&lang=js"
export * from "./add-components.vue?vue&type=script&lang=js"
import style0 from "./add-components.vue?vue&type=style&index=0&id=10ba9164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba9164",
  null
  
)

export default component.exports